import { useNavigate } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

import useUserStore from "@/stores/user";
import { instance } from "@/apis";
import { useQueryClient } from "@tanstack/react-query";
import { Text } from "../ui/text";
import LogoutIcon from "../ui/icons/LogoutIcon";
import MyPageIcon from "../ui/icons/MyPageIcon";
import { useTranslation } from "react-i18next";

const UserBox = () => {
  const { t } = useTranslation();
  const { user, clearUser, logId, clearLogId } = useUserStore();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const handleClick = async () => {
    try {
      // 1. 먼저 상태 클리어
      queryClient.clear();
      clearUser();
      clearLogId();

      // 2. 서버에 로그아웃 요청
      await instance.delete(`/api/user/sign-out?logId=${logId}`);
    } catch (error) {
      // 에러가 발생해도 로그아웃 처리는 진행
      console.error("Logout error:", error);
    }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <div className="flex items-center gap-[8px]">
          <Avatar>
            <AvatarImage src="/images/avatar.svg" />
            <AvatarFallback>
              {user?.firstName?.at(0)} {user?.lastName?.at(0)}
            </AvatarFallback>
          </Avatar>
          <Text variant={"title-md"} className="text-grey-20">
            {user?.firstName} {user?.lastName}
          </Text>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="p-1 w-[140px] flex flex-col gap-[2px]"
        sideOffset={20}
        align="start"
      >
        <DropdownMenuItem
          onClick={() => navigate("/home/mypage")}
          className="p-0"
        >
          <div className="w-10 h-10 flex justify-center items-center">
            <MyPageIcon />
          </div>
          <Text variant={"label-lg"} className="text-grey-20">
            {t("layout.myPage")}
          </Text>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleClick} className="p-0">
          <div className="w-10 h-10 flex justify-center items-center">
            <LogoutIcon />
          </div>
          <Text variant={"label-lg"} className="text-grey-20">
            {t("layout.logout")}
          </Text>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default UserBox;
